export default function InfoBanner({ icon: Icon, title, description }) {
  return (
    <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 flex gap-3">
      <Icon className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
      <div>
        <h4 className="text-sm font-semibold mb-1">{title}</h4>
        <p className="text-sm">{description}</p>
      </div>
    </div>
  );
}
